<div class="export-section d-flex flex-column align-items-center">
  <ng-content></ng-content>
</div>
